/**
 * @file
 * Slick setup for the Slider block (PBC-772).
 *
 * Deliberately separate from slider.js: that one drives the `slider`
 * paragraph, which uses arrows and an "n/total" counter. This block uses dots
 * and no arrows, and targets its own `.slider-block__items` selector so the
 * two never initialise over each other.
 *
 * Uses Drupal.behaviors + once so it also initialises on content returned by
 * Layout Builder's AJAX, not just on first page load.
 */
(function ($, Drupal, once) {
  Drupal.behaviors.pbcSliderBlock = {
    attach: function (context) {
      once("pbc-slider-block", ".slider-block__items", context).forEach(
        function (element) {
          var $slider = $(element);

          // Slick throws if it is initialised twice on the same element.
          if ($slider.hasClass("slick-initialized")) {
            return;
          }

          $slider.slick({
            autoplay: false,
            speed: 300,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            fade: true,
            adaptiveHeight: true,
          });
        }
      );
    },
  };
})(jQuery, Drupal, once);
